import { graphql, useFragment } from 'react-relay';
import PropTypes from 'prop-types';

// components
import { SbSharedRefineMenuMultiSelect } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelect.tsx';
import { SbSharedRefineMenuExpandableItemList } from '../SbSharedRefineMenuExpandableItemList/SbSharedRefineMenuExpandableItemList.tsx';

const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuMultiSelectList_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuMultiSelect_itemSearch
    }
`;
export const SbSharedRefineMenuMultiSelectList = ({
    itemSearch: itemSearchRef,
    collapsedItemCount = 5,
    filterName,
    shouldUseExpandableList = true,
    values,
    trackingOptions,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);

    if (!shouldUseExpandableList) {
        // skip the expandable list
        return (
            <SbSharedRefineMenuMultiSelect
                itemSearch={itemSearch}
                filterName={filterName}
                valuesToShow={values}
                trackingOptions={trackingOptions}
            />
        );
    }

    return (
        <SbSharedRefineMenuExpandableItemList
            filterName={filterName}
            availableFilterValues={values}
            collapsedItemCount={collapsedItemCount}
        >
            {({ valuesToShow }) => (
                <SbSharedRefineMenuMultiSelect
                    itemSearch={itemSearch}
                    filterName={filterName}
                    valuesToShow={valuesToShow}
                    trackingOptions={trackingOptions}
                />
            )}
        </SbSharedRefineMenuExpandableItemList>
    );
};

SbSharedRefineMenuMultiSelectList.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    collapsedItemCount: PropTypes.number,
    filterName: PropTypes.string.isRequired,
    shouldUseExpandableList: PropTypes.bool,
    values: PropTypes.array.isRequired,
    trackingOptions: PropTypes.object,
};
